<template>
  <div class="main-canvas" style="height: calc(100vh - 384px)">
    <b-overlay :show="isLoading" rounded="sm" spinner-variant="primary" opacity="0.6" style="height: 100%">
      <b-table
        :items="items"
        :fields="fields"
        class="bg-white allocationUnitsTable sum-header shadow-muted-super"
        id="nachtrag-table"
        bordered
        hover
        head-variant="light"
        show-empty
        small
        @row-clicked="item => $router.push('/orders/' + $route.params.id + '/addendums/' + item.DbId)"
        tbody-tr-class="action-button"
        ref="theTable"
        sticky-header="calc(100vh - 393px)"
      >
        <template #empty>
          <div class="text-center p-4">Keine Nachträge vorhanden</div>
        </template>
        <template #head(NHoehe)="data">
          <div style="padding-right: 2px">
            {{ data.label }}
          </div>
          <div class="font-weight-bold text-grey">
            {{ $utils.formatCurrency(sumE, SettingsStore) }}
          </div>
        </template>
        <template #head(NHoeheChecked)="data">
          <div style="padding-right: 2px">
            {{ data.label }}
          </div>
          <div class="font-weight-bold text-grey">
            {{ $utils.formatCurrency(sumG, SettingsStore) }}
          </div>
        </template>
        <template #head(AHoehe)="data">
          <div style="padding-right: 2px">
            {{ data.label }}
          </div>
          <div class="font-weight-bold text-grey">
            {{ $utils.formatCurrency(sumB, SettingsStore) }}
          </div>
        </template>
        <template #cell(actions)="data">
          <b-icon
            class="action-button text-grey"
            style="width: 18px; height: 18px"
            icon="arrow-right"
            @click.stop="$router.push('/orders/' + $route.params.id + '/addendums/' + data.item.DbId)"
          />
          <b-icon
            icon="trash"
            variant="grey"
            class="action-button ml-2"
            style="width: 16px; height: 16px"
            @click.stop="deleteRecord(data.item)"
            v-if="$root.$user.isPlaner || $root.$user.isAdmin"
          />
        </template>
        <template #cell(NHoeheChecked)="data">
          {{ data.item.Status !== '0' ? 'abgelehnt' : '' }}
          {{ data.item.Status == '0' ? $utils.formatCurrency(data.item.NHoeheChecked, SettingsStore) : '' }}
          {{ data.item.PDate && data.item.Status == '0' ? '(' + data.item.PDate + ')' : '' }}
        </template>
        <template #cell(AHoehe)="data">
          {{ $utils.formatCurrency(data.item.AHoehe, SettingsStore) }}
          {{ data.item.ADate ? '(' + data.item.ADate + ')' : '' }}
        </template>
      </b-table>
    </b-overlay>
  </div>
</template>
<style></style>
<script>
import AppState from '@/store/App.js';
//import AllocationUnitsService from '@/service/AllocationUnitsService';
//import ProjectStore from '@/store/Projects';
import SettingsStore from '@/store/Settings';
import OrdersService from '@/service/OrdersService.js';

export default {
  async activated() {
    this.loadAddendums();
    AppState.isLoading = false;
  },
  data() {
    return {
      fields: [
        {
          key: 'Nr',
          label: 'Nr.',
          thClass: ' align-top noselect'
        },
        {
          key: 'Inhalt',
          label: 'Inhalt',
          thClass: ' align-top noselect'
        },
        {
          key: 'NDate',
          label: 'Nachtragsdatum',
          formatter: x => this.$utils.SQLDateToGermanDate(x),
          thClass: ' align-top noselect'
        },
        {
          key: 'EDate',
          label: 'Eingangsdatum',
          thClass: ' align-top noselect'
        },
        {
          key: 'NHoehe',
          label: 'eingereicht',
          formatter: x => this.$utils.formatCurrency(x, SettingsStore),
          tdClass: 'text-right',
          thClass: 'text-right align-top noselect'
        },
        {
          key: 'NHoeheChecked',
          label: 'geprüft',
          tdClass: 'text-right',
          thClass: 'text-right align-top noselect'
        },
        {
          key: 'AHoehe',
          label: 'beauftragt',
          tdClass: 'text-right',
          thClass: 'text-right align-top noselect'
        },
        /*{
          key: 'PDate',
          label: 'geprüft am'
        },
        
        {
          key: 'ADate',
          label: 'beauftragt am',
          formatter: x => this.$utils.SQLDateToGermanDate(x)
        },*/
        {
          key: 'AText',
          label: 'Auftragstext',
          thClass: ' align-top noselect'
        },
        {
          key: 'actions',
          label: 'Aktionen',
          tdClass: 'bg-primary-light text-center',
          thClass: ' align-top noselect'
        }
      ],
      items: [
        {
          Nr: '1'
        }
      ],
      isLoading: true,
      SettingsStore,
      sumE: 0,
      sumG: 0,
      sumB: 0
    };
  },
  methods: {
    loadAddendums() {
      this.isLoading = true;
      this.sumE = 0;
      this.sumG = 0;
      this.sumB = 0;

      OrdersService.getAddendums(this.$route.params.id)
        .then(
          records =>
            (this.items = records.map(x => {
              x.EDate = this.$utils.SQLDateToGermanDate(x.EDate);
              x.PDate = this.$utils.SQLDateToGermanDate(x.PDate);
              x.BDate = this.$utils.SQLDateToGermanDate(x.BDate);
              x.ADate = this.$utils.SQLDateToGermanDate(x.ADate);
              this.sumE += x.NHoehe ? parseFloat(x.NHoehe) : 0;
              this.sumG += x.NHoeheChecked ? parseFloat(x.NHoeheChecked) : 0;
              this.sumB += x.AHoehe ? parseFloat(x.AHoehe) : 0;
              return x;
            }))
        )
        .catch(err => {
          if (err.response) this.$showError(this, err.response.data);
          else this.$showError(this, err.toString());
        })
        .finally(() => {
          this.isLoading = false;
          if (AppState.scrollPosition[this.$route.path])
            this.$refs.theTable.$el.scrollTo({
              top: AppState.scrollPosition[this.$route.path][0],
              left: AppState.scrollPosition[this.$route.path][1]
            });
        });
    },
    deleteRecord(item) {
      OrdersService.maybeAddendumDeleted(this.$route.params.id, item.DbId)
        .then(() => {
          this.$bvModal
            .msgBoxConfirm('Soll der Nachtrag wirklich gelöscht werden?', {
              title: 'Nachtrag löschen',
              okTitle: 'Bestätigen',
              cancelTitle: 'Abbrechen',
              okVariant: 'danger',

              centered: true
            })
            .then(confirmed => {
              if (confirmed) {
                OrdersService.deleteAddendum(this.$route.params.id, item.DbId)
                  .then(() => {
                    this.$utils.deleteItemFromArray(this.items, x => x.DbId == item.DbId);
                    this.$showSuccess(this, 'Nachtrag löschen', 'Nachtrag erfolgreich gelöscht');
                    this.$eventBus.$emit('update:nachtrag');
                  })
                  .catch(err => {
                    if (err.response) this.$showError(this, err.response.data.error);
                    else this.$showError(this, err.toString());
                  });
              }
            });
        })
        .catch(err => {
          if (err.response) {
            this.$bvModal.msgBoxOk(err.response.data.error, {
              title: 'Auftrag löschen',
              okTitle: 'Ok',
              okVariant: 'danger',

              centered: true
            });
          } else this.$showError(this, err.toString());
        });
    }
  },
  beforeRouteLeave(to, from, next) {
    AppState.scrollPosition[from.path] = [this.$refs.theTable.$el.scrollTop, this.$refs.theTable.$el.scrollLeft];
    next();
  }
};
</script>
<style>
#nachtrag-table.table-sm th,
#nachtrag-table.table-sm td {
  padding: 0.5rem !important;
}
</style>
